import Vue from 'vue';
import * as VeeValidate from 'vee-validate';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import VueShave from 'vue-shave';
import hljs from 'highlight.js';

let KadVue = {};

KadVue.install = function (Vue, options) {

  /******************************************
   * MIXINS
   * Used to inject global vars, methods, etc in VMs. Use sparingly.
   ******************************************/

  // Declaring a global Event Bus for communication between VMs
  const EventBus = new Vue();

  // Add to Vue properties by exposing a getter for $bus
  Object.defineProperties(Vue.prototype, {
    $bus: {
      get: function () {
        return EventBus;
      }
    }
  });

  Vue.mixin({
    data() {
      return {
        I18n,
        Kadenze,
      }
    },

    mounted() {
      const self = this;
      //Destroy this instance upon pjax nav
      $(document).on('pjax:start', function() {
        if (!self.skip_pjax_destroy) {
          self.$destroy();
        }
        $(document).off('pjax:start');
      });
    }
  });

  /******************************************
   * FILTERS
   * Used to transform/format strings
   ******************************************/

  Vue.filter('dateDisplay', function (value, opts) {
    opts = _.extend({}, opts, {dateFormat: 'js_default_time', dateSuffix: '', showRelative: false});
    let formattedDate = '';
    if (!_.isEmpty(value)) {
      let date = moment(value.replace(/\s\w{3,4}$/, ''), 'MM/DD/YYYY hh:mm A');
      if (!date.isValid()) {
        date = moment(value);
      }

      if (date && date.isValid()) {
        if (opts.showRelative) {
          formattedDate = date.fromNow();
        } else {
          formattedDate = date.format(Kadenze.I18n.t('date.formats.' + opts.dateFormat )) + opts.dateSuffix;
        }
      }
    }
    return formattedDate;
  });

  Vue.filter('numberToPercentage', function (value, precision, pad = true) {
    const fixedValue = Number(value).toFixed(precision);
    if (pad) {
      return  fixedValue + '%';
    }
    return  parseFloat(fixedValue) + '%';
  });

  Vue.filter('truncate', function (text, limit = 30) {
    return s.truncate(text, limit);
  });

  /******************************************
   * DIRECTIVES
   * Used with UI elements to manipulating or access their DOM
   ******************************************/

  Vue.directive('tooltip', {
    inserted: function (el, binding) {
      if ( binding.value !== null ) {
        let params = _.extend({}, { target: el }, binding.value);
        if(!Kadenze.UIUtil.isMobileOrTablet() && !params.disableOnMobile) {
          new Kadenze.Tooltip(params);
        }
      }
    },
    update: function (el, binding, vnode, oldvnode) {
      if (oldvnode !== vnode && binding.value && binding.value.rerenderOnUpdate) {
        let tooltip = $(el).data('tooltip');
        $(el).data('tooltip', null);
        if (tooltip)
          tooltip.destroy();
        let params = _.extend({}, { target: el }, binding.value);
        if(!Kadenze.UIUtil.isMobileOrTablet() && !params.disableOnMobile) {
          new Kadenze.Tooltip(params);
        }
      }
    },
    unbind: function (el, binding, vnode) {
      let tooltip = $(el).data('tooltip');
      $(el).data('tooltip', null);
      if (tooltip)
        tooltip.destroy();
    }
  });

  Vue.directive('focus', {
    inserted: function (el, binding, vnode) {
      if (binding.value) {
        el.focus();
      }
    }
  });

  Vue.directive('sticky', {
    inserted: function (el, binding, vnode) {
      Kadenze.UIUtil.initStickyScrollModule($(el), $(el).children(':first'), binding.value);
    }
  });

  Vue.directive('expandabletext', {
    inserted: function (el, binding, vnode) {
      $(el).each(function () {
        const $this = $(this);
        const $prompt = $('.prompt', $this).first();
        const $answer = $('.answer', $this).first();

        // open any text initially set to active
        if ($prompt.hasClass('active')) {
          $this.attr('aria-expanded', 'true');
          $answer.show().css('opacity', 1);
        }

        $('a', $prompt).first().off('click').on('click', function (e) {
          const $this = $(this);
          $prompt.toggleClass('active');
          const dur = 230;
          if ($prompt.hasClass('active')) {
            $this.attr('aria-expanded', 'true');
            $answer.slideDown(dur, 'easeInOutQuad').animate({
              opacity: 1
            }, {
              queue: false,
              duration: dur + 100
            });
          } else {
            $this.attr('aria-expanded', 'false');
            $answer.slideUp(dur, 'easeInOutQuad', function () {
              $(this).hide().css('opacity', 0);
            });
          }
          e.preventDefault();
        });
      });
    }
  });

  Vue.directive('track', {
    inserted: function (el, binding, vnode) {
      $(el).on('click', function() {
        let params = _.extend({}, { collection: null, type: null, data: {} }, binding.value);
        if (params.collection && params.type) {
          Kadenze.Analytics.track(params.collection, params.type, params.data);
        }
      });
    }
  });

  Vue.directive('tabkeyfocus', {
    inserted: function (el) {
      Kadenze.UIUtil.initTabKeyFocus(el);
    }
  });

  Vue.directive('clipboard', {
    inserted: function (el, binding) {
      var cb = new Clipboard(el, {
        text() {
          return binding.value;
        }
      });
      cb.on('success', function() {
        new Kadenze.Notice.success({
          message: 'Copied to clipboard!'
        });
      });
    }
  });

  /******************************************
   * COMPONENTS
   * Used to build complex UI elements that change the state of the VM and/or have custom markup and behavior
   ******************************************/

  Vue.component('selectpicker', require('./components/selectpicker.vue').default);
  Vue.component('share-modal', require('./components/share-modal.vue').default);
  Vue.component('generic-modal', require('./components/generic-modal.vue').default);
  Vue.component('mobile-modal', require('./components/mobile-modal.vue').default);
  Vue.component('cta-modal', require('./components/cta-modal.vue').default);
  Vue.component('filebox', require('./components/filebox.vue').default);
  Vue.component('read-more', require('./components/read-more.vue').default);
  Vue.component('toolbar-search-input', require('./components/toolbar-search-input.vue').default);
  Vue.component('flipswitch', require('./components/flipswitch.vue').default);
  Vue.component('checkbox', require('./components/checkbox.vue').default);
  Vue.component('wizard', require('./components/wizard.vue').default);
  Vue.component('panel-form', require('./components/panel-form.vue').default);
  Vue.component('media-viewer', require('./components/media-viewer/viewer.vue').default);
  Vue.component('course-card', require('./components/course-card.vue').default);
  Vue.component('kadenze-course-card', require('./components/kadenze-course-card.vue').default);
  Vue.component('micro-course-card', require('./components/micro-course-card.vue').default);
  Vue.component('program-card', require('./components/program-card.vue').default);
  Vue.component('review-card', require('./components/review-card.vue').default);
  Vue.component('quick-actions', require('./components/quick-actions.vue').default);
  Vue.component('datepicker', require('./components/datepicker.vue').default);
  Vue.component('quill', require('./components/quill.vue').default);

  Vue.component('kd-input-container', require('./components/kd-forms/kd-input/kd-input-container.vue').default);
  Vue.component('kd-input', require('./components/kd-forms/kd-input/kd-input.vue').default);

  /******************************************
   * VALIDATORS
   * Custom validators for the vee-validate lib
   ******************************************/

  VeeValidate.Validator.extend('dynamic_max_value', {
    getMessage(field, [compare], data) {
      let input = document.querySelector(`input[name='${compare}']`);
      return `The ${field} field must be ${input.value} or less.`;
    },
    validate(value, [compare]) {
      let input = document.querySelector(`input[name='${compare}']`);
      return !!(input && Number(value) <= Number(input.value));
    }
  });
};

Vue.use(KadVue);
Vue.use(VueShave);
Vue.use(VeeValidate, {enableAutoClasses: true, classNames: {invalid: 'error'}});
if (Kadenze.ENVIRONMENT !== 'development') {
  const sentryDSN = Kadenze.isKadenze ? 'https://69ae35e9ad9e4924af1bd56a27baa139@sentry.io/215591' : 'https://1712b18c48c44c6d8851eb2968ee452c@sentry.io/39947';
  Raven.config(sentryDSN, {
    release: Kadenze.VERSION,
    environment: Kadenze.ENVIRONMENT,
    ignoreUrls: [
      /cdn\.mxpnl\.com/,
      /cdn\.iubenda\.com/,
      /static\.hotjar\.com/
    ]
  }).addPlugin(RavenVue, Vue).install();
}


document.querySelectorAll('pre').forEach((block) => {
  hljs.highlightBlock(block);
});
